// extracted by mini-css-extract-plugin
export default {"container":"Pca-z","oos":"Qca-z","oosUx":"Rca-z","selected":"Sca-z","labelOos":"Tca-z"};